import { Directive, HostListener, Input } from '@angular/core';


@Directive({
  selector: '[appExpirationYear]'
})
export class ExpirationYearDirective {
  public Date = new Date();
  public Date2000= new Date("2000-01-01");  
  public actualYear= this.Date.getFullYear();
  public actualMonth=this.Date.getMonth();

  public futureYear3= Math.round(this.Date.setFullYear(this.Date2000.getFullYear())*0.0000166667*0.0000228154*0.083333);
  public futureYear2= Math.round(this.Date.setFullYear(this.actualYear)*0.0000166667*0.0000228154*0.083333)-this.futureYear3;
  public futureYear= Math.round(this.Date.setFullYear((this.Date.getFullYear()+5))*0.0000166667*0.0000228154*0.083333)-this.futureYear3;
 
  public validatoryear:number=null;

  
  constructor() {}
  public number:number=null;
  @Input('appExpirationYear') date:String; 
      @HostListener('keypress', ['$event']) onkeypress(ev) {
      let valid=false;
      if((ev.charCode >= 48 && ev.keyCode <= 57)){
        valid=true;
      }
      if( (ev.charCode == 46 || ev.charCode == 44)){
        valid=true;
      }
      if (!valid){
        ev.preventDefault();
      }


      if(ev.target.value.length<1){

        if((ev.charCode >= 50 && ev.keyCode <= 50 )){
          valid=true;
        }
        if( (ev.charCode == 46 || ev.charCode == 44)){
          valid=true;
        }
        if (!valid){
          ev.preventDefault();
        }
      }

     }
    @HostListener('blur', ['$event']) onblur(event) {
      if(event.target.value!=undefined && event.target.value!=""){
        if(event.target.value.length>1){
          
        }
      }
    }

    @HostListener('keyup', ['$event']) onkeyup(event) {
      if(event.target.value!=undefined && event.target.value!=""){
        if(event.target.value.length>1 ){
        if(event.target.value  >= this.futureYear2-1 && event.target.value <= this.futureYear ){
          event.target.value =event.target.value
        }
        else{ 
          event.preventDefault();
          event.target.value="";
        }

      }
        }
    }  
    
}
